import { AddRecentConversationUseCase } from './AddRecentConversationUseCase'
import { recentConversationsRepository } from '../../../data-access/repositories'

export const addRecentConversation = new AddRecentConversationUseCase({
  recentConversationsRepository,
}).execute
